var map = {
	"./EmOrder.vue": "870c",
	"./EmOrderCreate.vue": "a1af",
	"./EmProduct.vue": "7a28",
	"./EmProductDetail.vue": "91c1",
	"./EmResource.vue": "05c6",
	"./EmShippingTemplate.vue": "8cfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "80b3";